import { type ReactElement } from 'react';

const index = {
  label: 'CMS',
  href: '/',
};

const navigation = {
  main: {
    children: [
      {
        label: 'News',
        href: '/news',
        active: false,
      },
      {
        label: 'Team',
        href: '/team',
        active: false,
      },
    ],
  },
};

const Header = (): ReactElement => {
  return (
    <header className="shrink-0 sticky top-0" style={{ zIndex: 100 }}>
      <sdx-header
        index={index}
        navigation={navigation}
        skip-link-main-content-element-id="main-content"
      ></sdx-header>
    </header>
  );
};

export default Header;
